import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { IdentificadorMatrizFilialPipe, IdentificadorMatrizFilialBadgePipe } from './pipes';
import { IdentificadorMatrizFilialBadgeComponent } from './badge';
import { IdentificadorMatrizFilialInputGroupTextComponent } from './input-group-text';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        IdentificadorMatrizFilialPipe,
        IdentificadorMatrizFilialBadgePipe,
        IdentificadorMatrizFilialBadgeComponent,
        IdentificadorMatrizFilialInputGroupTextComponent
    ],
    exports: [
        IdentificadorMatrizFilialPipe,
        IdentificadorMatrizFilialBadgePipe,
        IdentificadorMatrizFilialBadgeComponent,
        IdentificadorMatrizFilialInputGroupTextComponent
    ],
    providers: [
        IdentificadorMatrizFilialPipe,
        IdentificadorMatrizFilialBadgePipe
    ]
})
export class IdentificadorMatrizFilialModule { }
